module.exports = __webpack_public_path__ + "static/media/Blaziken_gaussian2.69dcb108.png";